import { render } from "./BlogNewsList.vue?vue&type=template&id=7dac4984"
import script from "./BlogNewsList.vue?vue&type=script&lang=js"
export * from "./BlogNewsList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\cinnet_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__